import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export interface NavigationToastHandlerProps {
  showToast: (data: {
    message: string;
    type: "success" | "error" | "warning" | "info";
    linkId?: string;
    linkName?: string;
  }) => void;
}

const NavigationToastHandler: React.FC<NavigationToastHandlerProps> = ({
  showToast,
}) => {
  const location = useLocation();

  const lastKeyRef = useRef<string | null>(null);
  const lastLocationRef = useRef<string>("");

  useEffect(() => {
    const state = location.state as any;
    const locKey = (location as any).key || "";
    const locationKey = `${location.pathname}${location.search}`;

    const isNewLocation = lastLocationRef.current !== locationKey;
    const isNewKey = lastKeyRef.current !== locKey;

    if (isNewLocation || isNewKey) {
      if (state?.showToast) {
        window.history.replaceState({ ...state, showToast: undefined }, "");
        showToast(state.showToast);
      }
      lastKeyRef.current = locKey;
      lastLocationRef.current = locationKey;
    }
  }, [location, showToast]);

  return null;
};

export default NavigationToastHandler;
